export default __webpack_public_path__ + "static/media/close.243b25ca.webp";